import { mergeClasses } from 'minimal-shared/utils';

import { styled } from '@mui/material/styles';

import { navSectionClasses } from 'src/components/nav-section';

// ----------------------------------------------------------------------

export const Nav = styled('nav')``;

// ----------------------------------------------------------------------

export const NavLi = styled(
  (props: React.ComponentProps<'li'>) => (
    <li {...props} className={mergeClasses([navSectionClasses.li, props.className])} />
  ),
  { shouldForwardProp: (prop: string) => !['disabled', 'sx'].includes(prop) }
)<{ disabled?: boolean }>(() => ({
  display: 'inline-block',
  variants: [{ props: { disabled: true }, style: { cursor: 'not-allowed' } }],
}));

// ----------------------------------------------------------------------

export const NavUl = styled((props: React.ComponentProps<'ul'>) => (
  <ul {...props} className={mergeClasses([navSectionClasses.ul, props.className])} />
))(() => ({ display: 'flex', flexDirection: 'column' }));
